import { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useUserInfo } from '../shared/UserInfo';
import { fetchJsonWithAuth } from '../shared/fetch-json.util';
import { TEMPLATES } from '../shared/AppConstants';
import { callUserInfoAPI } from '../shared/APIHelper';
import { EntityLinksList } from '../shared/EntityLinksList';
import { sortedTemplateList } from '../shared/UtilFunctions';
import { getEnvVar } from '../utils/getEnvVar';

export default function StrategyFormTemplate(props) {
  const { incrementAPIInProgress, decrementAPIInProgress, setStatusErrorMsg } =
    props.commonProps;

  const info = useUserInfo();
  const tokenAvailable = info?.token;
  const [templateList, setTemplateList] = useState([]);
  const [userInfoMap, setUserInfoMap] = useState(new Map());

  useEffect(() => {
    callTemplate();
  }, [tokenAvailable]);

  function callTemplate() {
    incrementAPIInProgress();
    fetchJsonWithAuth(getEnvVar('VITE_TEMPLATE_API_URL'))
      .then((response) => {
        const unsortedList = response.json;
        const sortedList = sortedTemplateList(unsortedList);
        setTemplateList(sortedList);
      })
      .catch((error) =>
        setStatusErrorMsg(
          "Couldn't load the Template. Please try again.",
          error
        )
      )
      .finally(() => decrementAPIInProgress());
  }

  useEffect(() => {
    const userList = new Set();

    templateList?.forEach((item) => {
      if (item.createdById) userList.add(item.createdById);
      if (item.updatedById) userList.add(item.updatedById);
    });

    if (userList.size > 0)
      callUserInfoAPI(
        Array.from(userList),
        setUserInfoMap,
        null,
        incrementAPIInProgress,
        decrementAPIInProgress,
        setStatusErrorMsg,
        true
      );
  }, [templateList]);

  return (
    <>
      <Box mt={4}>
        {templateList?.length > 0 && (
          <Card>
            <CardContent>
              <Typography
                variant="h2"
                sx={(theme) => ({ mb: theme.fuel6Tokens.JddcSpacingMedium })}
              >
                {TEMPLATES}
              </Typography>
              <Box>
                <EntityLinksList
                  key={templateList}
                  entityName={'Template'}
                  setEntityData={setTemplateList}
                  entityData={templateList}
                  userInfoMap={userInfoMap}
                  isEdit={false}
                  apiUrl={`${getEnvVar('VITE_TEMPLATE_API_URL')}`}
                  commonProps={props.commonProps}
                />
              </Box>
            </CardContent>
          </Card>
        )}
      </Box>
    </>
  );
}
